import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ChevronDown, ArrowRight, Send } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen w-full overflow-hidden bg-dark-bg flex items-center justify-center" data-id="element-196">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-197">
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-dark-bg z-10" data-id="element-198" />
        <img src="https://images.unsplash.com/photo-1566737236500-c8ac43014a67?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Luxury Lounge Atmosphere" className="w-full h-full object-cover opacity-60" data-id="element-199" />
      </div>

      {/* Content */}
      <div className="relative z-20 container mx-auto px-4 text-center" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-201">
          <h2 className="text-gold-500 tracking-[0.2em] uppercase text-sm md:text-base mb-4 font-medium" data-id="element-202">
            SGLonelyGuy • 新加坡寂寞男人
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-203">
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white mb-6 leading-tight" data-id="element-204">
            为都市精英打造的
            <br data-id="element-205" />
            <span className="text-gold-gradient italic" data-id="element-206">私密伴游体验</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-207">
          <p className="text-gray-300 max-w-2xl mx-auto mb-10 text-lg md:text-xl font-light leading-relaxed" data-id="element-208">
            在繁华的新加坡，寻找一份真诚的陪伴。我们提供高端、私密、安全的社交伴游服务，让您的每一个夜晚都不再孤单。
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-209">
          <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" data-id="element-210">
            <Button size="lg" variant="primary" data-id="element-211">
              新加坡春风阁
            </Button>
          </a>
          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" data-id="element-212">
            <Button variant="outline" size="lg" leftIcon={<Send className="w-4 h-4" data-id="element-214" />} data-id="element-213">
              Telegram Channel
            </Button>
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20 text-white/50" initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      delay: 1.5
    }} data-id="element-215">
        <div className="flex flex-col items-center gap-2" data-id="element-216">
          <span className="text-xs uppercase tracking-widest" data-id="element-217">Scroll</span>
          <ChevronDown className="w-5 h-5" data-id="element-218" />
        </div>
      </motion.div>
    </section>;
}